import react from 'react'
import MyNavbar from '../../../components/user/general/mynavbar/MyNavbar';
import Footer from '../../../components/user/general/footer/Footer.js';
import GetInTouch from '../../../subscreens/users/Contact/getInTouch/GetInTouch.js';
import ContactBanner from '../../../subscreens/users/Contact/contactbanner/ContactBanner.js';
import GoogleMap from '../../../subscreens/users/Contact/googlemap/GoogleMap.js';

const Contact = () => {
    return (
        <>
            <MyNavbar />
            <ContactBanner />
            <GetInTouch />
            <GoogleMap/>
            <Footer />
        </>

    );

}
export default Contact;